var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container-sitc",
      staticStyle: { "padding-bottom": "0px" },
    },
    [
      _c(
        "div",
        { staticClass: "filter-container-content" },
        [
          _c(
            "el-form",
            {
              ref: "searchFormRef",
              attrs: {
                model: _vm.searchForm,
                "label-position": "top",
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label:
                              _vm.$t("booking.bookingTemplate.modelName") + ":",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.searchForm.bkNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "bkNo", $$v)
                              },
                              expression: "searchForm.bkNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label:
                              _vm.$t(
                                "booking.bookingTemplate.Portofdeparture"
                              ) + ":",
                          },
                        },
                        [
                          _c("gl-port", {
                            model: {
                              value: _vm.searchForm.stuff,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "stuff", $$v)
                              },
                              expression: "searchForm.stuff",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label:
                              _vm.$t(
                                "booking.bookingTemplate.Destinationport"
                              ) + ":",
                          },
                        },
                        [
                          _c("gl-port", {
                            model: {
                              value: _vm.searchForm.delName,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "delName", $$v)
                              },
                              expression: "searchForm.delName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: { label: _vm.$t("home.containerType") + ":" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.searchForm.containerType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "containerType", $$v)
                                },
                                expression: "searchForm.containerType",
                              },
                            },
                            _vm._l(_vm.containerTypeList, function (item) {
                              return _c("el-option", {
                                key: item,
                                attrs: { label: item, value: item },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.$t("booking.bookingTemplate.createTime") +
                              "：",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "datetimerange",
                              "range-separator": "——",
                              "start-placeholder": "",
                              "end-placeholder": "",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            on: { change: _vm.dateTimeChange },
                            model: {
                              value: _vm.dateValueFormItem,
                              callback: function ($$v) {
                                _vm.dateValueFormItem = $$v
                              },
                              expression: "dateValueFormItem",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c(
                      "div",
                      { staticStyle: { "margin-top": "28px" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-primary",
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.searchFormData()
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("booking.bookingTemplate.searchButton")
                              ) + "\n              "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-plain-primary",
                            on: {
                              click: function ($event) {
                                return _vm.resetForm()
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("booking.bookingTemplate.resetButton")
                              ) + "\n              "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-top": "28px",
                          "text-align": "right",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-primary",
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.addTemplate()
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "booking.bookingTemplate.addTemplateButton"
                                )
                              ) + "\n              "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-container-content" },
        [
          _vm._l(_vm.teplateData, function (item, index) {
            return _c(
              "div",
              {
                key: item.templateBookingHeadComId,
                staticClass: "content-template",
              },
              [
                _c("div", { staticClass: "template-top-area" }, [
                  _c("div", { staticClass: "template-left-text" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("home.myTemplate")) +
                        "：" +
                        _vm._s(item.bkNo) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "template-right-text" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("home.createTime")) +
                        "：" +
                        _vm._s(item.createdDtmLoc) +
                        "\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "template-center-area" }, [
                  _c(
                    "div",
                    { staticClass: "center-texts-area" },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 14 } },
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: { "margin-top": "10px" },
                              attrs: { span: 11 },
                            },
                            [
                              _c(
                                "el-row",
                                { staticStyle: { "margin-bottom": "10px" } },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "center-left-title" },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(_vm.$t("home.fwdDesc")) +
                                          "：\n                  "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("el-row", [
                                _c(
                                  "span",
                                  { staticClass: "center-left-text " },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "overflowWrap-text" },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(item.cargoDesc) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                { staticClass: "center-left-text" },
                                [
                                  _c("span", {
                                    staticClass: "center-left-text",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                { staticClass: "center-left-text" },
                                [
                                  _c("span", {
                                    staticClass: "center-left-text",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("el-row", [
                                _c("span", { staticClass: "center-left-text" }),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 1 } }, [
                            _c("div", { staticClass: "template-center-line" }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            {
                              staticStyle: { "margin-top": "10px" },
                              attrs: { span: 12 },
                            },
                            [
                              _c(
                                "el-row",
                                {
                                  staticStyle: { "margin-top": "10px" },
                                  attrs: { gutter: 14 },
                                },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 10 } },
                                    [
                                      _c("el-row", [
                                        _c(
                                          "span",
                                          { staticClass: "center-right-text" },
                                          [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(_vm.$t("home.por")) +
                                                " ：  " +
                                                _vm._s(item.stuff) +
                                                "\n                     "
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "el-row",
                                        {
                                          staticStyle: { "margin-top": "12px" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "center-right-text",
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "home.transportationTerms"
                                                    )
                                                  ) +
                                                  "：" +
                                                  _vm._s(
                                                    item.transportationTerms
                                                  ) +
                                                  "\n                     "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-row",
                                        {
                                          staticStyle: { "margin-top": "12px" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "center-right-text",
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "home.imoGrossWeight"
                                                    )
                                                  ) +
                                                  "：" +
                                                  _vm._s(
                                                    item.cargoGrossWeight
                                                  ) +
                                                  "\n                     "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 14 } },
                                    [
                                      _c("el-row", [
                                        _c(
                                          "span",
                                          { staticClass: "center-right-text" },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(_vm.$t("home.del")) +
                                                "：" +
                                                _vm._s(item.delName) +
                                                "\n                     "
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "el-row",
                                        {
                                          staticStyle: { "margin-top": "12px" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "center-right-text",
                                            },
                                            [
                                              _vm._v(
                                                "\n\n                        " +
                                                  _vm._s(
                                                    _vm.$t("home.paidType")
                                                  ) +
                                                  "：" +
                                                  _vm._s(
                                                    _vm.getPaidTypeListLabel(
                                                      item.paidType
                                                    )
                                                  ) +
                                                  "\n                     "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-row",
                                        {
                                          staticStyle: { "margin-top": "12px" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "center-right-text",
                                            },
                                            [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    _vm.$t("home.containerType")
                                                  ) +
                                                  "：" +
                                                  _vm._s(item.containerType) +
                                                  "\n                     "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "template-bottom-area" }, [
                  _c("div", { staticClass: "bottom-button-area" }, [
                    _c(
                      "div",
                      {
                        staticClass: "button-primary",
                        on: {
                          click: function ($event) {
                            return _vm.goToTemplateDetailBook(item, "booking")
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-edit-outline buttons-icon",
                        }),
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t("booking.bookingTemplate.bookingButton")
                            ) +
                            "\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "button-primary",
                        staticStyle: { "margin-left": "24px" },
                        on: {
                          click: function ($event) {
                            return _vm.goToTemplateDetail(item, "edit")
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "el-icon-edit buttons-icon" }),
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t(
                                "booking.bookingTemplate.editTemplateButton"
                              )
                            ) +
                            "\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "button-delete",
                        staticStyle: { "margin-left": "24px" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteTemplate(item)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-remove-outline buttons-icon",
                        }),
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t(
                                "booking.bookingTemplate.deleteTemplateButton"
                              )
                            ) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            )
          }),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "20px" } }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }